import React from 'react';
import logoSvg from '../resources/mm_logo.png';
import instagramIcon from '../resources/logo/InstagramLogo.svg';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container footer__inner">
                <div className="footer__left">
                    <div className="footer__brand">
                        <img
                            src={logoSvg}
                            alt="The M&amp;M Services logo"
                            className="footer__logo-img"
                        />
                        <div>
                            <div className="footer__title">THE M&amp;M SERVICES</div>
                        </div>
                    </div>
                    <div className="footer__service-areas">
                        Guelph • Kitchener • Waterloo • Cambridge
                    </div>
                </div>
                <div className="footer__right">
                    <a href="tel:+15197318214" className="footer__link">
                        +1 519-731-8214
                    </a>
                    <a href="mailto:Themnmservices@gmail.com" className="footer__link">
                        Themnmservices@gmail.com
                    </a>
                    <a
                        href="https://instagram.com/mnmservices"
                        target="_blank"
                        rel="noreferrer"
                        className="footer__link footer__link--icon"
                        aria-label="Visit The M&M Services on Instagram"
                    >
                        <img
                            src={instagramIcon}
                            alt=""
                            className="footer__icon-img"
                        />
                    </a>

                </div>
            </div>
            <div className="footer__bottom">
                © {new Date().getFullYear()} The M&amp;M Services. All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
